import React from "react";
import "./Footer.css";
import { FaLinkedinIn, FaTwitter, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import logo from "../../assets/logo.png";

const NAV_COLUMNS = [
  {
    heading: "Navigate",
    links: [
      { label: "About", path: "/about" },
      { label: "Services", path: "/approach/ai-strategy" },
      { label: "Solutions", path: "/impact/ai-readiness" },
      { label: "Insights", path: "/thinking" },
      { label: "Opportunities", path: "/insights" },
      { label: "Contact", path: "/contact" },
    ],
  },
  {
    heading: "Expertise",
    links: [
      { label: "AI Strategy & Roadmap", path: "/approach/ai-strategy" },
      { label: "Data & AI Platforms", path: "/approach/data-strategy" },
      { label: "Digital Core & Cloud", path: "/approach/digital-transformation" },
      { label: "Operating Model Transformation", path: "/approach/it-operations" },
      { label: "Change & Capability", path: "/approach/gcc-advisory" },
      { label: "Performance & Value", path: "/thinking/case-studies" },
    ],
  },
  {
    heading: "Industries",
    links: [
      { label: "Financial Services", path: "/industries/financial-services" },
      { label: "Manufacturing", path: "/industries/manufacturing" },
      { label: "Healthcare", path: "/industries/healthcare" },
      { label: "Retail & Consumer", path: "/industries/retail-consumer" },
      { label: "Energy & Utilities", path: "/industries/energy-utilities" },
      { label: "Technology", path: "/industries/technology" },
    ],
  },
  {
    heading: "Contact",
    links: [
      { label: "ramesh@bairees.com", path: "mailto:ramesh@bairees.com" },
      { label: "+1 (571) 663-5980", path: "tel:+15716635980" },
    ],
    extra: " USA | Europe | Middle East | APAC | India",
  },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* ── TOP SECTION ── */}
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <img src={logo} alt="BaiRees Global Advisory" className="footer-logo" />
            <p className="footer-tagline">
              Transformation Engineered
            </p>
            <div className="footer-socials">
              <a href="https://www.linkedin.com/in/ramesh-babu-bairy-8a34953" aria-label="LinkedIn" className="social-icon"><FaLinkedinIn /></a>
              <a href="https://twitter.com" aria-label="Twitter"  className="social-icon"><FaXTwitter /></a>
              <a href="https://youtube.com" aria-label="YouTube"  className="social-icon"><FaYoutube /></a>
            </div>
          </div>

          {/* Link columns */}
          <nav className="footer-nav">
            {NAV_COLUMNS.map((col) => (
              <div key={col.heading} className="footer-col">
                <h4 className="footer-col-heading">{col.heading}</h4>
                <ul className="footer-col-list">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a href={link.path} className="footer-link">{link.label}</a>
                    </li>
                  ))}
                  {col.extra && (
                    <li className="footer-cities">{col.extra}</li>
                  )}
                </ul>
              </div>
            ))}
          </nav>
        </div>

        {/* ── GOLD DIVIDER ── */}
        <div className="footer-divider" />

        {/* ── BOTTOM BAR ── */}
        <div className="footer-bottom">
          <p className="footer-copy">
            © 2026 BaiRees Global Advisory. All rights reserved.
          </p>
          <div className="footer-policies">
            <a href="/privacy-policy" className="footer-policy-link">Privacy Policy</a>
            <span className="footer-policy-sep">|</span>
            <a href="/terms-of-use" className="footer-policy-link">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
}